/*
 * @author: wayou
 * @date: 2018-08-23 12:14:48
 * @description: 加入班级
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

interface IOutput {
    status: number;
}

export const joinClass = (classId: string): Promise<IResponse<IOutput>> => {
    return fetchData(Api.JOIN_CLASS, {
        class_id: classId,
    }).then((res: IResponse<IOutput>) => {
        return res;
    });
};
